import { render, staticRenderFns } from "./VistaResumen.vue?vue&type=template&id=1757836b&scoped=true"
import script from "./VistaResumen.vue?vue&type=script&lang=js"
export * from "./VistaResumen.vue?vue&type=script&lang=js"
import style0 from "./VistaResumen.vue?vue&type=style&index=0&id=1757836b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1757836b",
  null
  
)

export default component.exports